export const convertToPersianNumber = (number) => (new Number(number)).toLocaleString('fa-ir')